import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '复播课程名称',
      placeholder: '请输入复播课程名称'
    }
  ]
}
